import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AppAuthService} from '@app/auth';
import {Capacitor} from '@capacitor/core';
import {of} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {AuthSessionRecoveryService} from './auth-session-recovery.service';
import {SessionService} from './session.service';

@Injectable({providedIn: 'root'})
export class AuthGuardService implements CanActivate {

	constructor(
		private authService: AppAuthService,
		private router: Router,
		private sessionService: SessionService,
		private recoveryService: AuthSessionRecoveryService,
	) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (route?.queryParams?.['restaurantId']) {
			this.sessionService.setRestaurant({id: route.queryParams['restaurantId']});
		} else if (route?.queryParams?.['resto']) {
			this.sessionService.setRestaurant({id: route.queryParams['resto']});
		}

		return this.authService.isAuthenticated().pipe(
			take(1),
			switchMap(authenticated => {
				if (authenticated) {
					return of(true);
				}
				if (Capacitor.isNativePlatform()) {
					return this.recoveryService.recoverSession().pipe(
						map(recovered => {
							if (recovered) {
								return true;
							}
							this.redirectToLogin(state.url);
							return false;
						}),
					);
				}
				this.redirectToLogin(state.url);
				return of(false);
			}),
		);
	}

	private redirectToLogin(url: string): void {
		if (!url.startsWith('/auth')) {
			SessionService.setWantedUrl(url);
		}
		void this.router.navigateByUrl('/auth/login');
	}
}
